import React from "react";

import { useDocumentTitle } from "hooks/useDOcumentTitle";
import RoamingItemsClientList from "components/RoamingItems/RoamingItemsList/RoamingItemsClientList/RoamingItemsClientList";

const RoamingItemsClientPage: React.FC = () => {
  useDocumentTitle("Client Roaming Items");
  return <RoamingItemsClientList></RoamingItemsClientList>;
};

export default RoamingItemsClientPage;